import React from 'react'
import Messages from '../constants/messages';

export const ForgotPasswordEmailExpired = () => {
  return (
    <div data-test-id="forgotPasswordEmailExpiredPage">
      {Messages['pageMessages']['SELF_SERVICE_RESET_PASSWORD_EXPIRATION_MSG']}
    </div>
  )
}